import recipe1 from '../../assets/media/recipes/recipe-1.png';
import recipe2 from '../../assets/media/recipes/recipe-2.png';
import recipe3 from '../../assets/media/recipes/recipe-3.png';
import recipe4 from '../../assets/media/recipes/recipe-4.png';
import recipe5 from '../../assets/media/recipes/recipe-5.png';
import recipe6 from '../../assets/media/recipes/recipe-6.png';
import recipe7 from '../../assets/media/recipes/recipe-7.png';
import recipe8 from '../../assets/media/recipes/recipe-8.png';
import recipe9 from '../../assets/media/recipes/recipe-9.png';
import recipe10 from '../../assets/media/recipes/recipe-10.png';
import recipe11 from '../../assets/media/recipes/recipe-11.png';
import recipe12 from '../../assets/media/recipes/recipe-12.png';
import recipe13 from '../../assets/media/recipes/recipe-13.png';
import recipe14 from '../../assets/media/recipes/recipe-14.png';

import video1 from '../../assets/media/recipes/recipe-1.mp4';

import recipePoster1 from '../../assets/media/recipes/recipe-poster-1.png';

const recipes: Irecipe[] = [
  {
    id: 1,
    image: recipe1,
    shortName: 'Aperini & Tonic',
    name: 'Santo Stefano Aperini & Tonic',
    alcohol: '13.5%',
    complexity: 'Простой',
    time: '5 минут',
    taste: 'Сладкий',
    ingredients: 'Лёд (кубики) – 200 гр.<br />Santo Stefano Aperini – 100 мл.<br />Indian Tonic – 100 мл.<br />Долька апельсина',
    descr: 'Берем бокал, наполняем бокал льдом, наливаем Santo Stefano Aperini, добавляем индиан тоник, перемешиваем коктейль, добавляем дольку апельсина',
    video: video1,
    poster: recipePoster1,
    productIds: [2]
  },
  {
    id: 2,
    image: recipe2,
    shortName: 'Bianco & Tonic',
    name: 'Santo Stefano Bianco & Tonic',
    alcohol: '7%',
    complexity: 'Простой',
    time: '2 минуты',
    ingredients: '- 100 мл аперитив Santo Stefano Bianco<br />- 100 мл Indian Tonic<br />- Долька лайма<br />- Лед',
    descr: '1. Смешайте аперитив Santo Stefano Bianco и тоник в бокале со льдом.<br />2. Легко перемешайте.<br />3. Добавьте дольку лайма.',
    productIds: [1]
  },
  {
    id: 3,
    image: recipe3,
    shortName: 'Rosato & Tonic',
    name: 'Santo Stefano Rosato & Tonic',
    alcohol: '13.5%',
    complexity: 'Простой',
    time: '5 минут',
    ingredients: 'Лёд (кубики) – 200 гр.<br />Santo Stefano Rosato – 100 мл.<br />Indian Tonic – 100 мл.<br />Веточка мяты',
    descr: 'Берем бокал, наполняем бокал льдом, наливаем Santo Stefano Rosato, добавляем индиан тоник, перемешиваем коктейль, добавляем веточку мяты',
    productIds: [3]
  },
  {
    id: 4,
    image: recipe4,
    shortName: 'Limoncello Spritz',
    name: 'Santo Stefano Limoncello Spritz',
    alcohol: '14%',
    complexity: 'Простой',
    time: '5 минут',
    ingredients: '- 60 мл Santo Stefano Limoncello<br />- 90 мл просекко<br />- 30 мл содовой<br />- Лёд, слайс лимона / веточка мяты',
    descr: '1. Смешайте Santo Stefano Limoncello и просекко в бокале со льдом.<br />2. Добавьте содовую и легко перемешайте.<br />3. Украсьте слайсом лимона или веточкой мяты.',
    productIds: [24]
  },
  {
    id: 5,
    image: recipe5,
    shortName: 'Gelato al Limoncello',
    name: 'Santo Stefano Gelato al Limoncello',
    alcohol: '10%',
    complexity: 'Простой',
    time: '1-2 минуты',
    ingredients: '- 30 мл Santo Stefano Limoncello<br />- 2-3 шарика ванильного мороженого',
    descr: '1. Положите шарики ванильного мороженого в охлаждённый бокал креман.<br />2. Перед подачей налейте 30 мл охлаждённого Santo Stefano Limoncello поверх мороженого.',
    productIds: [24]
  },
  {
    id: 6,
    image: recipe6,
    shortName: 'Sgroppino al Limoncello',
    name: 'Santo Stefano Sgroppino al Limoncello',
    alcohol: '13%',
    complexity: 'Средний',
    time: '3-4 минуты',
    ingredients: '- 40 мл Santo Stefano Limoncello<br />- 10 мл водки<br />- 60 мл сухого игристого вина<br />- 1 шарик лимонного или цитрусового сорбета',
    descr: '1. Поместите сорбет в охлаждённый бокал креман.<br />2. Полейте сорбет Santo Stefano Limoncello и водку.<br />3. Размешайте/разомните ложкой до кремовой массы.<br />4. Добавьте игристое вино и легко перемешайте.',
    productIds: [24]
  },
  {
    id: 7,
    image: recipe7,
    shortName: 'Punch al Limoncello',
    name: 'Santo Stefano Punch al Limoncello',
    alcohol: '5%',
    complexity: 'Простой',
    time: '2 минуты',
    ingredients: '- 60 мл Santo Stefano Limoncello<br />- 25–30 мл свежего лимонного сока<br />- 1 ч. л. мёда<br />- 200 мл горячей воды (70–80°C)<br />- долька лимона',
    descr: '1. Налейте горячую воду (70–80°C) в бокал.<br />2. Смешайте мед и лимонный сок.<br />3. Добавьте Santo Stefano Limoncello и легко перемешайте.<br />4. Украсьте долькой лимона.',
    productIds: [24]
  },
  {
    id: 8,
    image: recipe8,
    shortName: 'Pera Tonic',
    name: 'Santo Stefano Pera Tonic',
    alcohol: '3%',
    complexity: 'Простой',
    time: '5 минут',
    ingredients: '- 30 мл аперитив Santo Stefano Bianco<br />- 30 мл грушевого сока<br />- 120 мл тоника<br />- Лед, слайс груши',
    descr: '1. Смешайте аперитив Santo Stefano Bianco и грушевый сок в бокале со льдом.<br />2. Добавьте тоник и легко перемешайте.<br />3. Украсьте слайсом груши.',
    productIds: [1]
  },
  {
    id: 9,
    image: recipe9,
    shortName: 'Bianco Mare',
    name: 'Santo Stefano Bianco Mare',
    alcohol: '8%',
    complexity: 'Простой',
    time: '3 минуты',
    ingredients: '- 60 мл аперитив Santo Stefano Bianco<br />- 20 мл джина<br />- 40 мл грейпфрутового сока<br />- 120 мл содовой<br />- Лед, долька грейпфрута',
    descr: '1. Смешайте аперитив Santo Stefano Bianco, джин и грейпфрутовый сок в бокале со льдом.<br />2. Добавьте содовую и легко перемешайте.<br />3. Украсьте долькой грейпфрута.',
    productIds: [1]
  },
  {
    id: 10,
    image: recipe10,
    shortName: 'Aperini Spritz',
    name: 'Santo Stefano Aperini Spritz',
    alcohol: '11%',
    complexity: 'Простой',
    time: '5 минут',
    ingredients: '- 90 мл сухого игристого<br />- 60 мл аперитив Santo Stefano Aperini<br />- 30 мл содовой<br />- Лед',
    descr: '1. Смешайте аперитив Santo Stefano Aperini и игристое вино в бокале со льдом.<br />2. Добавьте содовую и легко перемешайте.<br />3. Украсьте долькой апельсина.',
    productIds: [2]
  },
  {
    id: 11,
    image: recipe11,
    shortName: 'Rosato Spritz',
    name: 'Santo Stefano Rosato Spritz',
    alcohol: '12%',
    complexity: 'Простой',
    time: '5 минут',
    ingredients: '- 60 мл аперитив Santo Stefano Rosato<br />- 90 мл сухое игристое вино<br />- 30 мл содовой<br />- Лед, долька грейпфрута',
    descr: '1. Смешайте аперитив Santo Stefano Rosato и игристое вино в бокале со льдом.<br />2. Добавьте содовую и легко перемешайте.<br />3. Украсьте долькой грейпфрута.',
    productIds: [3]
  },
  {
    id: 12,
    image: recipe12,
    shortName: 'Rosato Glow',
    name: 'Santo Stefano Rosato Glow',
    alcohol: '5%',
    complexity: 'Простой',
    time: '5 минут',
    ingredients: '- 50 мл аперитив Santo Stefano Rosato<br />- 25 мл клюквенного морса/сока<br />- 120мл безалкогольного игристого Brut Rosé Zero<br />- Лед, долька клубники',
    descr: '1. Смешайте аперитив Santo Stefano Rosato и клюквенный морс в бокале со льдом.<br />2. Добавьте безалкогольное игристое Brut Rosé Zero и легко перемешайте.<br />3. Украсьте дольку клубники.',
    productIds: [3]
  },
  {
    id: 13,
    image: recipe13,
    shortName: 'Rosso Gelato Zero',
    name: 'Santo Stefano Rosso Gelato Zero',
    alcohol: '0%',
    complexity: 'Простой',
    time: '2-3 минуты',
    ingredients: '-100 мл Santo Stefano Rosso Zero<br />- Ванильное мороженое<br />- Тертый шоколад',
    descr: '1. Выложите шарик мороженого в бокал.<br />2. Добавьте Santo Stefano Rosso Zero.<br />3. Украсьте тёртым шоколадом или ягодами винограда.',
    productIds: [5,16]
  },
  {
    id: 14,
    image: recipe14,
    shortName: 'Rosé Fizz Zero',
    name: 'Santo Stefano Rosé Fizz Zero',
    alcohol: '0%',
    complexity: 'Простой',
    time: '2-3 минуты',
    ingredients: '-150 мл Santo Stefano Brut Rosé Zero<br />- 30 мл сока манго<br />- 10 мл свежевыжатого лимонного сока<br />- Мята<br />- Лед',
    descr: '1. Смешайте сок манго и сок лимона в бокале со льдом.<br />2. Добавьте Santo Stefano Brut Rosé Zero и легко перемешайте.<br />3. Украсьте листиком мяты.',
    productIds: [17]
  }
];

export default recipes;